export function warningAceptarCancelarConfirming(content) {
    return new Promise((resolve) => {
        $.confirm({
            columnClass: 'col-md-6',
            icon:        'ri-alert-fill ri-xxs',
            title:       'Atención',
            type:        'orange',
            content:     content,
            buttons:     {
                confirm: {
                    text:     'Confirmar',
                    btnClass: 'btn btn-success float-end',
                    action:   function () {
                        const $btn = this.$content.closest('.jconfirm').find('.btn-success');
                        $btn
                            .prop('disabled', true)
                            .html('<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Procesando...');
                        resolve(true);
                    }
                },
                cancel:  {
                    text:     'cancelar',
                    btnClass: 'btn btn-light float-start',
                    action:   function () {
                        resolve(false);
                    }
                }
            },
        });
    });
}
